import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from "@angular/material/dialog";
import { History } from '../../_model/history-response/history';
import { HistoryResponse } from '../../_model/history-response/history-response';
import { TableResponse } from '../../_model/table-response/table-response';
import { Constants } from '../../_model/constants';
import { CommonModule, DatePipe } from '@angular/common';
import { environment } from '../../../environments/environment';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
@Component({
  selector: 'app-invoice-dialog',
  templateUrl: './invoice-dialog.component.html',
  standalone: true,
  imports: [DatePipe,MatCardModule, CommonModule, MatDialogModule, MatButtonModule ],
  styleUrls: ['./invoice-dialog.component.scss']
})
export class InvoiceDialogComponent implements OnInit {

  public responseData: TableResponse | null = null;
  public item: any;
  tableData!: TableResponse;
  tableDisplayedColumns!: string[];
  constructor(public datepipe: DatePipe, public matDialogRef: MatDialogRef<InvoiceDialogComponent, History>,
    @Inject(MAT_DIALOG_DATA) public data: { invoice: TableResponse; trigger: ElementRef; item: any }) { }

  ngOnInit() {
    this.responseData = this.data.invoice;
    this.item = this.data.item;
    if(this.responseData?.data?.tableRows){
      // let i : any;
      this.responseData.data.tableRows.forEach((row)=> {
          if(environment.locale === "en-GB"){
            row.createdDate = this.datepipe.transform( row.createdDate, Constants.dateFormatEngbHistory);
            row.modifiedDate = this.datepipe.transform( row.modifiedDate, Constants.dateFormatEngbHistory);
          }
           else if(environment.locale === "en-US"){
            row.createdDate = this.datepipe.transform( row.createdDate, Constants.dateFormaten029History);
            row.modifiedDate = this.datepipe.transform( row.modifiedDate, Constants.dateFormaten029History);
           }
      })
    }
    
 this.tableDisplayedColumns = this.responseData?.data?.tableDefinitions?.map(c => c.columnDef) || [];
  }

  hasTableRows(): boolean {
    return !!this.responseData?.data?.tableRows?.length;
  }

  hasLineItems(row: any): boolean {
    return !!row?.lineItems?.length;
  }

  isError(): boolean {
    return !!this.responseData?.status && this.responseData.status !== 'SUCCESS';
  }
}



